import { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  sectionTitle: string;
  sectionSubtitle: string;
  items: FAQItem[];
}

export default function FAQSection({ sectionTitle, sectionSubtitle, items }: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            {sectionTitle}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {sectionSubtitle}
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggleItem(index)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "pb-5 max-h-96" : "max-h-0"
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}